import type { DecodedJWT } from "../types";

const ACCESS_TOKEN_KEY = "mozio-auth-token";
const REFRESH_TOKEN_KEY = "mozio-refresh-token";

export const setAccessToken = (token: string) => {
  localStorage.setItem(ACCESS_TOKEN_KEY, token);
};

export const setRefreshToken = (token: string) => {
  localStorage.setItem(REFRESH_TOKEN_KEY, token);
};

export const getAccessToken = (): string | undefined => {
  return localStorage.getItem(ACCESS_TOKEN_KEY) ?? undefined;
};

export const getRefreshToken = (): string | undefined => {
  return localStorage.getItem(REFRESH_TOKEN_KEY) ?? undefined;
};

export const removeTokens = () => {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
};

export const decodeJWT = (token: string): DecodedJWT => {
  try {
    const payloadEncoded = token.split(".")[1];
    if (!payloadEncoded) {
      throw new Error("Invalid JWT format");
    }
    const payload = JSON.parse(window.atob(payloadEncoded));

    return { payload } as DecodedJWT;
  } catch (error) {
    throw new Error("Error decoding JWT: " + error);
  }
};
